// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__38Xh3","active":"downloadDropdown_active__3TKb4"};